import { render, staticRenderFns } from "./customer-attribute.vue?vue&type=template&id=a5068c16&scoped=true&"
import script from "./customer-attribute.vue?vue&type=script&lang=js&"
export * from "./customer-attribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5068c16",
  null
  
)

export default component.exports